module.exports = __webpack_public_path__ + "img/ls6.5507246d.png";